import { createTheme, responsiveFontSizes } from "@mui/material";
import CheckIconVms from "../assets/icons/checked_icon_vms.svg";
import UnCheckIcon from "../assets/icons/uncheck_icon.svg";
import { selectedTheme, tenants } from "../utils/constant";
import { alpha } from "@mui/material/styles";

const PrimaryColor = "#2563EB";

const mcsmsPalette = {
  primary: {
    main: PrimaryColor,
    light: "#EFF6FF",
    dark: PrimaryColor,
  },
  text: {
    primary: "#0F172A",
    secondary: "#64748B",
  },
  background: {
    default: "#F8FAFC",
    paper: "#FFFFFF",
  },
  success: {
    main: "#16A34A",
    light: "#DCFCE7",
  },
  error: {
    main: "#DC2626",
  },
  grey: {
    50: "#FAFAFA",
  },
};

const columnHeaderColors = {
  [tenants.VMS]: mcsmsPalette.primary.light,
};

const paletteMap = {
  [tenants.VMS]: mcsmsPalette,
  default: mcsmsPalette,
};

let MuiTheme = createTheme({
  palette: paletteMap[selectedTheme] || paletteMap.default,
  typography: {
    fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
        text: {
          color: PrimaryColor,
        },
        colorInherit: {
          borderColor: "rgba(62, 62, 62, 1)",
          color: "rgba(62, 62, 62, 1)",
        },
        containedPrimary: {
          color: "#FFF",
        },
      },
      defaultProps: {
        size: "large",
        disableElevation: true,
        disableTouchRipple: true,
        variant: "contained",
        color: "primary",
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            background: "#f7f7f7",
            border: "1px solid #d9d9d9",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          },
        },
      },
    },
    MuiAvatar: {
      defaultProps: {
        variant: "rounded",
        sx: {
          width: 25,
          height: 25,
        },
      },
    },
    MuiMenuList: {
      defaultProps: {
        dense: true,
      },
    },
    MuiRadio: {
      defaultProps: {
        icon: (
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              border: "2px solid #C5C5C5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        ),
        checkedIcon: (
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              border: `2px solid ${PrimaryColor}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: PrimaryColor,
                position: "absolute",
              }}
            />
          </div>
        ),
      },
    },
    MuiCheckbox: {
      defaultProps: {
        icon: <img src={UnCheckIcon} alt="uncheck_icon" />,
        checkedIcon: <img src={CheckIconVms} alt="checked_icon" />,
        size: "small",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
    MuiDataGrid: {
      defaultProps: {
        sx: {
          "& .MuiDataGrid-columnHeader": {
            backgroundColor:
              columnHeaderColors[selectedTheme] || mcsmsPalette.primary.light,
          },
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#F9FAFB",
          },
        },
        slotProps: {
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        },
        autoHeight: true,
        localeText: {
          noRowsLabel: "No Data",
        },
      },
    },
  },
});

if (!MuiTheme.alpha) {
  MuiTheme.alpha = alpha;
}

export default MuiTheme = responsiveFontSizes(MuiTheme);
